<template>
  <section id="about-us" class="pt-6 md:pt-10 pb-10 md:pb-16 scroll-mt-20">
    <Motion
      :initial="{ opacity: 0, y: 30 }"
      :whileInView="{ opacity: 1, y: 0 }"
      :transition="{ duration: 0.7 }"
      :viewport="{ once: true, margin: '-100px' }"
  class="text-center mb-12 md:mb-14"
    >
      <h2 class="text-3xl md:text-4xl font-bold mb-4 text-slate-800 ">
        About <span class="text-yellow-500 ">Us</span>
      </h2>
      <p class="text-lg text-gray-700  max-w-2xl mx-auto">
        The couple behind the ducks and the joy they bring to cruise ships
      </p>
    </Motion>

    <div class="flex flex-col md:flex-row items-center gap-12">
      <!-- Image Section -->
      <Motion
        class="md:w-1/2"
        :initial="{ opacity: 0, x: -50 }"
        :whileInView="{ opacity: 1, x: 0 }"
        :transition="{ duration: 0.7 }"
        :viewport="{ once: true, margin: '-100px' }"
      >
        <div class="relative">
          <img 
            src="/aboutus.webp" 
            alt="Picture of us on a cruise ship" 
            class="w-full h-auto rounded-xl shadow-lg object-cover"
            @error="handleImageError"
          />
          <div class="absolute inset-0 bg-blue-500/10  rounded-xl"></div>
          
          <!-- Duck overlay decoration -->
          <div class="absolute -bottom-4 -right-4 bg-white p-2 rounded-full shadow-lg">
            <v-icon color="yellow" size="large">mdi-duck</v-icon>
          </div>
        </div>
      </Motion>

      <!-- Text Section -->
      <Motion
        class="md:w-1/2"
        :initial="{ opacity: 0, x: 50 }"
        :whileInView="{ opacity: 1, x: 0 }"
        :transition="{ duration: 0.7 }"
        :viewport="{ once: true, margin: '-100px' }"
      >
        <div class="bg-white/80  backdrop-blur-sm rounded-xl p-6 shadow-lg">
          <h3 class="text-2xl font-bold mb-4 text-slate-800 ">Our Story</h3>
          
          <p class="text-gray-700  mb-4">
            We're a couple who absolutely loves cruising around the world. During one of our voyages, we started hiding rubber ducks throughout the ship for others to find, a simple activity that brought unexpected joy to everyone involved.
          </p>
          
          <p class="text-gray-700  mb-4">
            What began as a fun hobby quickly evolved as we realized how much people enjoyed finding these little surprises. Finders would track us down to share their excitement, and many wished there was a way to connect with the person behind the duck.
          </p>
          
          <p class="text-gray-700 ">
            That's how DuckNSeek was born, we wanted to create an interactive experience that lets people leave messages and feedback when they find a duck, creating connections and spreading joy across the high seas.
          </p>
        </div>
      </Motion>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Motion } from 'motion-v';

// Handle image errors (in case the image doesn't exist yet)
const handleImageError = (e: Event) => {
  const target = e.target as HTMLImageElement;
  target.src = '/ducksImages/duckPlaceholder.webp';
};
</script>

<style scoped>
/* Subtle animations */
.animate-float {
  animation: float 3s ease-in-out infinite;
  will-change: transform;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-15px) rotate(5deg); }
}


/* Improve image responsiveness */
@media (max-width: 768px) {
  img {
    max-height: 300px;
    width: 100%;
    object-fit: cover;
  }
}
</style>